module.exports = __webpack_public_path__ + "static/media/code.b3207424.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/createReactApp/code.png
// module id = 49
// module chunks = 0